function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import MyAccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import PaginationVue from '@/components/PaginationVue';
import SegmentTablesComponent from '@/apps/audiences/components/SegmentTablesComponent';
import { ARRAY_TYPE_ELEMENTS, TYPE_ELEMENTS, ROLES_LIST, GA_EVENTS } from '@/js/constants';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
export default {
  name: 'AddBaseIdsComponent',
  components: {
    SegmentTablesComponent: SegmentTablesComponent,
    PaginationVue: PaginationVue
  },
  props: {
    useCase: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      page: 1,
      pageCount: 0,
      partyIdSelected: null,
      itemsPerPage: 5,
      pagination: {
        current: 1,
        limit: 10,
        total: 0
      },
      valid: true,
      columns_selected: [],
      viewsData: [],
      tableSearch: {},
      serviceAccount: 'dev-itc-dp-bigquery-work@dev-intercorp-data-operation.iam.gserviceaccount.com',
      isValidatingTable: false,
      items: [],
      partyId: null,
      baseID: {},
      keySearchTable: 1,
      base_attributes: []
    };
  },
  created: function created() {
    this.getObjectAccess();
  },
  methods: {
    updateSelected: function updateSelected(value) {
      this.columns_selected = value;
    },
    toggleSelectAll: function toggleSelectAll() {
      if (this.allSelected) {
        this.columns_selected = [];
      } else {
        this.columns_selected = this.items;
      }
    },
    getObjectAccess: function getObjectAccess() {
      var _this = this;
      this.columns_selected = [];
      this.base_atributes = [];
      this.viewsData = [];
      var params = {
        user: this.serviceAccount,
        sandbox: {
          id: this.useCase.id,
          technical_name: this.useCase.technical_name
        }
      };
      MyAccessService.getObjectAccess('attributes', params).then(function (response) {
        console.log(response);
        if (response && response.data) {
          response.data.forEach(function (element) {
            _this.viewsData.push({
              text: element.table.id,
              value: element.view.projectId + '.' + element.view.datasetId + '.' + element.view.objectId,
              data: element
            });
          });
        }
      });
    },
    onTableSelected: function onTableSelected() {
      var _this2 = this;
      this.columns_selected = [];
      if (this.viewsData.length > 0 && Object.keys(this.tableSearch).length > 0) {
        var params = {
          relativeResourceName: this.tableSearch.data.relativeResourceName,
          domain_table: this.tableSearch.data.domain
        };
        var consulta = {
          tables: [{
            datasetId: this.tableSearch.data.view.datasetId,
            domain_table: this.tableSearch.data.domain,
            projectId: this.tableSearch.data.view.projectId,
            source: "bigquery",
            tableId: this.tableSearch.data.view.objectId,
            is_view: true,
            always_get: true
          }]
        };
        //AssignmentsService.getApprovedColumns(params).then(response => {
        AssignmentsService.getTablesDetails(consulta).then(function (response) {
          if (response && response.code == 200 && response.data[_this2.tableSearch.data.view.projectId + ":" + _this2.tableSearch.data.view.datasetId + "." + _this2.tableSearch.data.view.objectId]) {
            var table_detail = response.data[_this2.tableSearch.data.view.projectId + ":" + _this2.tableSearch.data.view.datasetId + "." + _this2.tableSearch.data.view.objectId];
            var approved_columns = [];
            var approved_columns_dict = {};
            table_detail.schema.fields.forEach(function (co) {
              approved_columns.push(co.name);
              approved_columns_dict[co.name] = {
                "name": co.name,
                "type": co.type
              };
            });
            /*console.log(response)
            let approved_columns = []
            if (response && response.data) {
              approved_columns = response.data.columns
            }*/
            AssignmentsService.getListTagEntry(params).then(function (response) {
              if (response && response.code === 200) {
                var responseTPL = response.data;
                var tableTags = responseTPL.objects.tags;
                var columnTags = tableTags.filter(function (tag) {
                  return tag.column && approved_columns.includes(tag.column);
                });
                columnTags.forEach(function (i) {
                  i.type = approved_columns_dict[i.column].type;
                });
                _this2.items = columnTags;
                _this2.columns_selected = [];
                _this2.partyId = null;
                _this2.keySearchTable += 1;
                _this2.$refs.form.resetValidation();
              }
            });
          }
        });
      }
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    onSubmit: function onSubmit(event) {
      var _this3 = this;
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      var newColumnPartyId = this.items.find(function (element) {
        return element.column === _this3.partyIdSelected;
      });
      console.log(newColumnPartyId, this.items, this.partyIdSelected);
      if (newColumnPartyId.type !== "STRING") {
        tasks.toast.warning("Debe seleccionar una columna de tipo STRING.");
        return;
      }
      this.addPartyIdRow();
      var table = this.tableSearch.data.table;
      var view = this.tableSearch.data.view;
      var newAttributes = this.columns_selected.map(function (item) {
        return {
          attribute_name: item.column,
          attribute_object_name: view.objectId,
          attribute_scheme_name: view.datasetId,
          attribute_project_name: view.projectId,
          attribute_description: item.fields.business_definition.stringValue,
          is_partyid: _this3.partyId === item.column ? '1' : '0',
          is_external: '1',
          attribute_source_id: 2,
          attribute_filters: {},
          attribute_category: 'Table INCA',
          attribute_dtype: item.fields.type.stringValue,
          attribute_notnull: -1,
          company_code_usr: _this3.companyCode
        };
      });
      if (!this.base_atributes) {
        this.base_atributes = [];
      }
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.ADD_BASE_INCA,
          table: this.tableSearch.data.table.id,
          view: this.tableSearch.data.view.id,
          use_case: this.useCase.business_name,
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          module: 'attributes_marketplace'
        });
      }
      this.useCase.attributes = newAttributes;
      this.baseID.table = table;
      this.baseID.partyID = this.partyId;
      console.log(this.useCase.attributes);
      this.$emit('update:baseID', this.useCase, this.baseID);
    },
    addPartyIdRow: function addPartyIdRow() {
      var _this4 = this;
      this.partyId = this.partyIdSelected;
      console.log(this.partyIdSelected);
      if (this.partyId) {
        var indexColumn = this.columns_selected.findIndex(function (element) {
          return element.column === _this4.partyId;
        });
        var newColumnPartyId = this.items.find(function (element) {
          return element.column === _this4.partyIdSelected;
        });
        console.log(newColumnPartyId);
        if (newColumnPartyId.type !== "STRING") {
          tasks.toast.warning("Debe seleccionar una columna de tipo STRING.");
          return;
        }
        if (indexColumn !== -1) {
          this.columns_selected.splice(indexColumn, 1);
          this.columns_selected.push(newColumnPartyId);
        } else {
          this.columns_selected.push(newColumnPartyId);
        }
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode'])), {}, {
    headers: function headers() {
      return [{
        text: this.translate('table_add_ids.attribute'),
        value: 'column'
      }, {
        text: this.translate('table_add_ids.definition'),
        value: 'fields.business_definition.stringValue'
      }, {
        text: this.translate('table_add_ids.type'),
        value: 'type'
      }];
    },
    allSelected: function allSelected() {
      // Verifica si todas las filas están seleccionadas
      return this.columns_selected.length === this.items.length;
    },
    indeterminate: function indeterminate() {
      // Verifica si algunas filas están seleccionadas, pero no todas
      return this.columns_selected.length > 0 && this.columns_selected.length < this.items.length;
    },
    rules: function rules() {
      return {
        useCase: [function (v) {
          return !!v || 'Selecciona un caso de uso';
        }],
        projectId: [function (v) {
          return !!v || 'Seleccione un proyecto';
        }],
        datasetId: [function (v) {
          return !!v || 'Ingrese un dataset';
        }],
        tableId: [function (v) {
          return !!v || 'Ingrese la tabla';
        }],
        partyId: [function (v) {
          return !!v || 'Selecciona un Party Id';
        }]
      };
    } // partyIdSelected: {
    //   get() {
    //     return this.partyId
    //   },
    //   set(value) {
    //     if (this.partyId) {
    //       const indexColum = this.columns_selected.findIndex(element => element.column === this.partyId)
    //       const newColumnPartyId = this.items.find(element => element.column === value)
    //       console.log(indexColum)
    //       if (indexColum !== -1) {
    //         this.columns_selected.splice(indexColum, 1)
    //         this.columns_selected.push(newColumnPartyId)
    //       }
    //     } else {
    //       const columnPartyId = this.items.find(element => element.column === value)
    //       if (columnPartyId) {
    //         this.columns_selected.push(columnPartyId)
    //       }
    //     }
    //     this.partyId = value
    //   }
    // }
  })
};